module.exports = __webpack_public_path__ + "img/it_it_day-11.59301282.svg";